import { SET_ESTIMATED_COST, SET_ESTIMATED_COST_PERIOD, SET_SCHEDULER_STATUS } from '../mutation-types';

const state = {
  amount: '',
  selectedPeriod: '',
  schedulerStatus: {}
}

const getters = {
  amount: state => {
    return state.amount;
  }
}

const actions = {
  calculateAmount({ commit, state }) {
    const {
      prices,
      stopHour,
      startHour,
      schedulerDays,
      isEnabled
    } = state.schedulerStatus;
    
    const calculateNumberOfSpecificDaysInMonth = (specificDay) => {
      const currentDate = new Date();
      let date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );

      let day = 1;
      let counter = 0;

      while (date.getMonth() === currentDate.getMonth()) {
        if (date.getDay() === specificDay) {
          counter++;
        }
        day++;
        date = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          day
        );
      }

      return counter;
    }

    const getNumberOfDaysInMonth = () => {
      const date = new Date();
      return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth() + 1,
        0
      ).getDate();
    }

    const pricesPerHour = prices.map(price => Number.parseFloat(price));

    if (!isEnabled) {
      if (state.selectedPeriod === "hour") {
        let amount = 0;
        pricesPerHour.forEach(price => amount += price)
        commit(SET_ESTIMATED_COST, amount.toFixed(2));
      }
      else if (state.selectedPeriod === "day") {
        let amount = 0;
        pricesPerHour.forEach(price => amount += price * 24)
        commit(SET_ESTIMATED_COST, amount.toFixed(2));
      }
      else if (state.selectedPeriod === "month") {
        const daysInMonth = getNumberOfDaysInMonth();
        let amount = 0;
        pricesPerHour.forEach(price => amount += price * 24 * daysInMonth)
        commit(SET_ESTIMATED_COST, amount.toFixed(2));
      }
    } else {
      if (state.selectedPeriod === "hour") {
        let amount = 0;
        pricesPerHour.forEach(price => amount += price)
        commit(SET_ESTIMATED_COST, amount.toFixed(2));
      }
      else if (state.selectedPeriod === "day") {
        let amount = 0;
        pricesPerHour.forEach(price => amount += (stopHour !== '' && startHour !== ''
          ? price * (Number.parseInt(stopHour) - Number.parseInt(startHour))
          : 0))
        commit(SET_ESTIMATED_COST, amount.toFixed(2));
      } else if (state.selectedPeriod === "month") {
        const hoursPerDay = (Number.parseInt(stopHour) - Number.parseInt(startHour));
        let daysInMonth = 0;
        schedulerDays.split(",").map(day =>
          daysInMonth += calculateNumberOfSpecificDaysInMonth(Number.parseInt(day))
        );
        let amount = 0;
        pricesPerHour.forEach(price => amount += (schedulerDays && stopHour !== '' && startHour !== ''
          ? price * hoursPerDay * daysInMonth : 0))
        commit(SET_ESTIMATED_COST, amount.toFixed(2));
      }
    }
  },
  setPeriod({ commit }, period) {
    commit(SET_ESTIMATED_COST_PERIOD, period);
  },
  setSchedulerStatus({ commit }, status) {
    commit(SET_SCHEDULER_STATUS, status);
  }
}

const mutations = {
  [SET_ESTIMATED_COST](state, payload) {
    state.amount = payload;
  },
  [SET_ESTIMATED_COST_PERIOD](state, payload) {
    state.selectedPeriod = payload;
  },
  [SET_SCHEDULER_STATUS](state, payload) {
    state.schedulerStatus = payload;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}

